<!--
 * @Author: luxiangqiang
 * @Date: 2023-04-26 14:08:33
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-05-15 10:30:33
-->
<template>
  <div class="calculation-wrapper">
    <h2 class="title">{{ title }}</h2>
    <div class="calculation">
      <a-form class="form" ref="formRef" size="large" :model="formData">
        <a-input-group>
          <a-form-item field="countryCode" :rules="[{ required: true, message: '国家为必填' }]" :validate-trigger="['change']"
            hide-asterisk>
            <a-select v-model="formData.countryCode" :options="concatCountryList" :style="{ width: '130px' }"
              placeholder="请选择国家" />
          </a-form-item>
          <a-form-item field="amount" :rules="[
            { required: true, message: '年度薪资为必填' },
            { type: 'number', maxLength: 6, max: 1000000, message: '年度薪资不能大于100万' },
            { type: 'number', min: 0, message: '年度薪资不能小于0' },
          ]" :validate-trigger="['change']" hide-asterisk model-event="input">
            <a-input v-model="formData.amount" :style="{ width: '200px' }" placeholder="请输入薪资" />
          </a-form-item>
          <a-button type="primary" @click="handleCalc">
            开始计算
            <img style="width: 25px" src="@/assets/icons/arrow.svg" alt="arrow" />
          </a-button>
        </a-input-group>
      </a-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { countryList, deelCountryList } from '@/common/global';
import { FormInstance } from '@arco-design/web-vue';

const formRef = ref<FormInstance | null>(null);
const concatCountryList = computed(() => {
  if (props.showDeelCountry) {
    return countryList.concat(deelCountryList).map(item => ({
      label: item.desc,
      value: item.code,
    }));
  } else {
    return countryList.map(item => ({
      label: item.desc,
      value: item.code,
    }));
  }
});

const props = defineProps<{
  title: string;
  countryCode: string;
  amount: number;
  showDeelCountry?: boolean;
}>();

const route = useRoute();
const formData = reactive({
  countryCode: '',
  amount: '',
});

onMounted(() => {
  formData.countryCode = props.countryCode;
  formData.amount = String(props.amount);
});

const handleCalc = async () => {
  const res = await formRef.value?.validate();
  if (res) {
    return false;
  }
  const countryName = concatCountryList.value?.find(c => c.label === formData.countryCode)?.label;
  useLogger().track('calculator', {
    country: countryName,
    salary: formData.amount,
  });

  await navigateTo({
    path: route.path,
    query: {
      ...route.query,
      ...formData,
    },
  });
  window.location.reload();
};
</script>

<style scoped lang="less">
:deep(.arco-form-item-label-col) {
  display: none;
}

:deep(.arco-form-item-message) {
  margin-bottom: -30px;
}

.calculation-wrapper {
  padding-top: 25px;
  width: 680px;
  margin: 0px auto;

  .title {
    color: #1d2129;
  }

  :deep(.arco-row) {
    margin-bottom: 0;
  }

  .calculation {
    margin-top: 20px;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    width: fit-content;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 4px;
    box-sizing: border-box;
    background-color: #fff;

    :deep(.arco-input-wrapper),
    :deep(.arco-input-focus) {
      border: 0;
    }

    :deep(.arco-select-view-single) {
      position: relative;
      background-color: #fff;
      border: 0;

      &::after {
        position: absolute;
        top: 20%;
        right: 0;
        content: '';
        display: block;
        width: 1px;
        height: 20px;
        background-color: #e5e6eb;
      }
    }

    :deep(.arco-input-wrapper) {
      background-color: #fff;
    }
  }
}
</style>
